import { useEffect, useLayoutEffect } from 'react';

/**
 * https://eight-bites.blog/en/2021/05/uselayouteffect-ssr/
 * serverside 에서는 useLayoutEffect 가 동작이 되지 않아 dom mismatch 가 일어날 수 있다.
 * useLayoutEffect 를 사용해야 할때 useIsomorphicEffect 를 사용하도록 하자.
 */
const useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export default useIsomorphicEffect;
